import React from 'react';
import PropTypes from 'prop-types';
import ToolTipIcon from '../../../components/ToolTipIcon/ToolTipIcon';
import { getPermissions } from '../../../utils/getPermissions';

function PlaylistActions(props) {
  const { showDuplicateDialog, showFolderSelector, onDelete } = props;
  const { auth, id } = props;
  const p = getPermissions(auth);

  if (!id || !p.writer) {
    return [];
  }

  return (
    <div
      data-test="playlist-actions"
      className="grid grid-cols-[repeat(5,_max-content)] md:grid-cols-[repeat(7,_max-content)] xl:grid-cols-[repeat(14,_max-content)] gap-2 mt-8"
    >
      <ToolTipIcon toolText="Delete Playlist">
        <button
          type="button"
          onClick={onDelete}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/delete_button.svg"
            alt="Delete"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
      {p.atLeastTierPro && (
        <ToolTipIcon toolText="Move Playlist">
          <button
            type="button"
            onClick={showFolderSelector}
            className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
          >
            <img
              src="/assets/images/icons/paste_button.svg"
              alt="Delete"
              className="w-[30px] h-[30px]"
              draggable={false}
            />
          </button>
        </ToolTipIcon>
      )}
      <ToolTipIcon toolText="Duplicate Playlist">
        <button
          data-test="location-copy-setting"
          type="button"
          onClick={async () => {
            showDuplicateDialog();
          }}
          className="duration-500 hover:scale-105 w-[50px] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
        >
          <img
            src="/assets/images/icons/copy_button.svg"
            alt="Copy"
            className="w-[30px] h-[30px]"
            draggable={false}
          />
        </button>
      </ToolTipIcon>
    </div>
  );
}

PlaylistActions.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      permissions: PropTypes.shape({
        Writer: PropTypes.bool,
      }),
    }),
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showFolderSelector: PropTypes.func.isRequired,
  showDuplicateDialog: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default PlaylistActions;
